import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import { Slide, ToastContainer } from "react-toastify";

import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import Signup from './pages/signup';
import Login from './pages/login';
import AdminLogin from './pages/AdminP/admin-login';
import Admindashboard from './pages/AdminP/admin-dashboard';
import Survey from './pages/survey';
import Search from './pages/search';
import PreSignup from './pages/pre-signup';
import Contactus from './pages/contactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import PeopleProfile from './pages/people-profile-page';
import CompanyProfile from './pages/company-profile-page';
import Inpuserlisting from './pages/inp-user-listing';
import Company from './pages/company';
import AddCompany from './pages/add-company';
import About from './pages/about';
import ProtectedRoute from './components/UserC/ProtectedRoute';
import AdminProtectedRoute from './components/AdminC/AdminProtectedRoute';
import AdminProvider from './context/AdminContext';
import AdminDashboardContent from './pages/AdminP/AdminDashboardContent';
import AdminCompany from './pages/AdminP/AdminCompanies';
import AdminInpPanel from './pages/AdminP/AdminInpPanel';
import AdminWallet from './pages/AdminP/AdminWallet';
import AdminSurveyManagement from './pages/AdminP/AdminSurveyManagement';
import AdminAddCompany from './pages/AdminP/AdminAddCompany';
import MyProfile from './pages/MyProfile';
import People from './pages/People';
import CustomCursor from './reactbits/Ribbons';
import ScrollToTop from './components/ScrollToTop';

import Dashboard from './pages/dashboard/dashboard';

import BottomNavbar from './components/BottomNavbar';
import CreateSurveyLayout from './dashboard_layout/createSurveyLayout';
import MySurveys from './pages/dashboard/MySurveys';
import MyWallet from './pages/dashboard/MyWallet';
import SearchResults from './pages/dashboard/SearchResults';
import MembershipSignup from './pages/membershi-signup';

import CreateSurveyStep1 from './pages/dashboard/CreateSurveyStep1';
import CreateSurveyStep2 from './pages/dashboard/CreateSurveyStep2';
import CreateSurveyPreview from './pages/dashboard/CreateSurveyPreview';

import EditSurveyStep1 from './pages/MySurveys/EditSurveyStep1';
import EditSurveyStep2 from './pages/MySurveys/EditSurveyStep2';
import EditSurveyPreview from './pages/MySurveys/EditSurveyPreview';

import SurveyForMe from './pages/dashboard/SurveysForMe';
import TakeSurvey from './pages/dashboard/TakeSurvey';
import ForgetPassword from './pages/ForgetPassword';
import NewPassword from './pages/NewPassword';
import CookiePolicy from './pages/CookiePolicy';
import SavedSurveysPage from './pages/dashboard/SavedSurveysPage';
import AccountSecurity from './pages/dashboard/AccountSecurity';
import NotificationSettings from './pages/dashboard/NotificationSettings';
import Support from './pages/dashboard/Support';
import Profile from './pages/dashboard/Profile';
import ProfileSetup from './pages/dashboard/ProfileSetup';
import SurveyResults from './pages/dashboard/SurveyResults';

import { WalletProvider } from "./context/WalletContext";


function AppContent() {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const currentPath = location.pathname.toLowerCase();
  // const hideFooterOnDashboard = location.pathname.toLowerCase() === '/dashboard';


  const hideFooterRoutes = [
    "/feed",
    "/search-results",
    "/create-survey",
    "/my-surveys",
    "/survey-for-me",
    "/take-survey",
    "/my-wallet",
    "/settings",
    "/survey-results",
  ];

  const hideFooterOnDashboard = hideFooterRoutes.some((route) =>
    currentPath.startsWith(route)
  );


  // const hideFooterOnDashboard = currentPath === '/dashboard' || currentPath.startsWith('/dashboard/');



  // Hide Header and Footer on /AdminLogin, /Admindashboard, and /Company (case-insensitive)
  const hideLayout = ['/adminlogin', '/admindashboard', '/admindashboard/companies', '/admindashboard/companies/add-new-company', '/admindashboard/inp-panel', '/admindashboard/wallet', '/admindashboard/survey-management'].includes(location.pathname.toLowerCase());

  // const hideLayout = ['/adminlogin', '/admindashboard', '/admindashboard/companies','/admindashboard/companies/add-new-company', '/admindashboard/inp-panel','/admindashboard/wallet','/admindashboard/survey-management'].includes(currentPath);


  console.log({
    currentPath,
    hideLayout,
    hideFooterOnDashboard,
  });

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    const checkLoginStatus = () => {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      setIsLoggedIn(Boolean(token && user));
    };

    checkLoginStatus();
    window.addEventListener('storage', checkLoginStatus);

    return () => {
      window.removeEventListener('storage', checkLoginStatus);
    };
  }, [location.pathname]);


  return (
    <>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        stacked
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="light"
        transition={Slide}
        toastStyle={{ fontSize: "14px", fontWeight: 500, color: "#000", padding: "4px 16px" }}
      />
      {!hideLayout && <Header />}

      <AdminProvider>

        <CustomCursor />

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />
          <Route path="/set-password" element={<NewPassword />} />
          <Route path="/reset-password" element={<NewPassword />} />
          {/* <Route path="/signup" element={<Signup />} /> */}
          <Route path="/membershi-signup" element={<MembershipSignup />} />
          <Route path="/signup" element={<PreSignup />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/myprofile" element={<MyProfile />} />
          {/* <Route path="/search-results" element={<SearchResults />} /> */}


          <Route
            element={
              <ProtectedRoute>
                <CreateSurveyLayout />
              </ProtectedRoute>
            }
          >

            <Route path="/search-results" element={<SearchResults />} />

            <Route
              path="/feed"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/create-survey"
              element={<Navigate to="/create-survey/step-1" replace />}
            />

            <Route
              path="/create-survey/step-1"
              element={
                <ProtectedRoute>
                  <CreateSurveyStep1 />
                </ProtectedRoute>
              }
            />

            <Route
              path="/create-survey/step-2/:surveyId"
              element={
                <ProtectedRoute>
                  <CreateSurveyStep2 />
                </ProtectedRoute>
              }
            />

            <Route
              path="/create-survey/preview/:surveyId"
              element={
                <ProtectedRoute>
                  <CreateSurveyPreview />
                </ProtectedRoute>
              }
            />

            <Route
              path="/my-surveys"
              element={
                <ProtectedRoute>
                  <MySurveys />
                </ProtectedRoute>
              }
            />

            <Route
              path="/survey-results/:surveyId"
              element={
                <ProtectedRoute>
                  <SurveyResults />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-survey"
              element={<Navigate to="/edit-survey/step-1" replace />}
            />

            <Route
              path="/edit-survey/step-1"
              element={
                <ProtectedRoute>
                  <EditSurveyStep1 />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-survey/step-2/:surveyId"
              element={
                <ProtectedRoute>
                  <EditSurveyStep2 />
                </ProtectedRoute>
              }
            />

            <Route
              path="/edit-survey/preview/:surveyId"
              element={
                <ProtectedRoute>
                  <EditSurveyPreview />
                </ProtectedRoute>
              }
            />







            <Route
              path="/survey-for-me"
              element={
                <ProtectedRoute>
                  <SurveyForMe />
                </ProtectedRoute>
              }
            />

            <Route
              path="/saved-surveys"
              element={
                <ProtectedRoute>
                  <SavedSurveysPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/take-survey/:surveyId"
              element={
                <ProtectedRoute>
                  <TakeSurvey />
                </ProtectedRoute>
              }
            />
            <Route
              path="/survey/:surveyId"
              element={
                <ProtectedRoute>
                  <TakeSurvey />
                </ProtectedRoute>
              }
            />


            <Route
              path="/my-wallet"
              element={
                <ProtectedRoute>
                  <MyWallet />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings"
              element={<Navigate to="/settings/account-security" replace />}
            />

            <Route
              path="/settings/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings/profile/setup"
              element={
                <ProtectedRoute>
                  <ProfileSetup />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings/account-security"
              element={
                <ProtectedRoute>
                  <AccountSecurity />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings/notifications"
              element={
                <ProtectedRoute>
                  <NotificationSettings />
                </ProtectedRoute>
              }
            />

            <Route
              path="/settings/support"
              element={
                <ProtectedRoute>
                  <Support />
                </ProtectedRoute>
              }
            />

          </Route>



          <Route
            path="/Survey"
            element={
              <ProtectedRoute>
                <Survey />
              </ProtectedRoute>
            }
          />

          <Route path="/search" element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          }
          />
          <Route path="/PeopleProfile/:member_id" element={
            <ProtectedRoute>
              <PeopleProfile />
            </ProtectedRoute>
          }
          />
          <Route path="/CompanyProfile/:company_id" element={
            <ProtectedRoute>
              <CompanyProfile />
            </ProtectedRoute>
          }
          />
          <Route path="/Inpuserlisting" element={
            <ProtectedRoute>
              <Inpuserlisting />
            </ProtectedRoute>
          }
          />
          <Route path="/Company" element={
            <ProtectedRoute>
              <Company />
            </ProtectedRoute>
          }
          />
          <Route path="/AddCompany" element={
            <ProtectedRoute>
              <AddCompany />
            </ProtectedRoute>
          }
          />
          {/* Admin Routes  */}
          <Route path="/adminLogin" element={<AdminLogin />} />
          <Route path="/admindashboard" element={<AdminProtectedRoute> <Admindashboard /></AdminProtectedRoute>}>
            <Route index element={<AdminDashboardContent />} />
            <Route path="companies" element={<AdminCompany />} />
            <Route path="inp-panel" element={<AdminInpPanel />} />
            <Route path="wallet" element={<AdminWallet />} />
            <Route path="survey-management" element={<AdminSurveyManagement />} />
            <Route path="companies/add-new-company" element={<AdminAddCompany />} />
          </Route>
        </Routes>

      </AdminProvider>

      {!hideLayout && isLoggedIn && <BottomNavbar />}
      {!hideLayout && !hideFooterOnDashboard && <Footer />}






    </>
  );
}

function App() {
  return (
    <WalletProvider>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </WalletProvider>
  );
}

export default App;
